import React from 'react'

import styles from './SavedCardItem.module.scss'

const SavedCardItem = ({ card, isSelected, onSelect }) => (
    <div
        className={`${styles.savedCard} ${isSelected ? styles.savedCardSelected : ''}`}
        onClick={() => onSelect(card)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && onSelect(card)}
    >
        <div className={styles.savedCardRadio}>
            <div className={isSelected ? styles.radioFilled : styles.radioEmpty} />
        </div>
        <div className={styles.savedCardInfo}>
            <span className={styles.savedCardBrand}>{card.card_type || 'Card'}</span>
            <span className={styles.savedCardNumber}>•••• {card.last4_digits}</span>
        </div>
    </div>
);


export default SavedCardItem
